import React from 'react';
import ConfirmModal from '../Elements/UI/ConfirmModal';

const Conformationdocumentmodal = ({ show, onClose, onDelete }) => {
  return (
    <ConfirmModal
      show={show}
      onClose={onClose}
      onConfirm={onDelete}
      title="Delete document?"
      message="This document will be removed for everyone. This can't be undone."
    />
  );
};

export default Conformationdocumentmodal;
